module.exports = __webpack_public_path__ + "static/media/nuova.22fb016a.png";